import EditListItemContext from "@/contexts/EditListItemContext";
import { FC, useContext } from "react";
import SelectedListItem from "@/features/list/components/SelectedListItem";
import Button from "@/components/Button";

const SelectedListItemBar: FC = (): JSX.Element => {
  const { selectedItems, deleteHandler } = useContext(EditListItemContext);

  return (
    <div className="fixed bottom-0 inset-x-0 z-[9999] bg-white shadow-default">
      <div className="text-center text-black bg-yellow-500 font-bold h-[32px] leading-[32px] text-xs laptop:h-[44px] laptop:leading-[44px]">
        リストから削除するアイテムを選択してください
      </div>
      {selectedItems.length > 0 && (
        <div className="flex items-center p-8 laptop:p-12 space-x-12 laptop:space-x-16">
          <div className="flex-1 overflow-x-scroll hidden-scrollbar">
            <ul className="flex items-center space-x-8 laptop:space-x-12">
              {selectedItems.map((item) => {
                return (
                  <li key={item.id}>
                    <SelectedListItem listItem={item} />
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="flex flex-0 items-center space-x-8">
            <Button onClick={deleteHandler} color="danger">
              削除
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectedListItemBar;
